<div class="dialog-container">
  <div class="dialog-dismiss" (click)="onRejectAction()">
    <img src="assets/plan/back-gray.svg" />
  </div>
  <div class="dialog-title">{{ title }}</div>
  <div class="dialog-description">{{ description }}</div>
  <div
    class="dialog-not-show-again-box"
    [ngClass]="notShowAgain ? 'box-selected' : 'box-not-selected'"
    (click)="changeShowStatus()"
  >
    <img *ngIf="notShowAgain" src="assets/general/tick-white.png" />
  </div>
  <div class="dialog-not-show-again">این پیام را دیگر نشان ندهید.</div>
  <div class="dialog-top-button" (click)="onContinue()">ادامه</div>
  <div class="dialog-bottom-button" (click)="onChangePlan()">
    تغییر برنامه غذایی
  </div>
</div>
